export enum AlertDialogConfirmTypeEnum {
    OkCancel=0,
    YesNo=1
}


// WEBPACK FOOTER //
// ./src/app/_enums/alert_dialog_confirm_type.enum.ts